module.exports = __webpack_public_path__ + "static/star_loading-d199626da8d71a456d9d698f51b116d4.gif";